package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.screens.mikud.model.BookState
import kotlinx.collections.immutable.toImmutableList

class PopulateBookUseCase {

    operator fun invoke(mikud: MutableList<BookState>, index: Int, chapters: List<Int>) {
        mikud[index] = mikud[index].copy(
            chapters = List(mikud[index].chapters.size) { it.plus(1) in chapters }.toImmutableList(),
        )
    }
}
